import { envs } from '@/app/lib/config/envs';
import { kebabCase } from '@/app/lib/utils/string';

export const getTailframesReactComponentGithubUrl = (componentName: string, { isDir = false }: { isDir?: boolean } = {}) => {
  const name = kebabCase(componentName).toLowerCase();

  return `${envs.githubTailframesComponentsUrl}/blob/main/components/${isDir ? `${name}/` : ''}${name}.tsx`;
};

export const getTailframesStorybookUrl = (componentName: string) =>
  `https://storybook.tailframes.com/?path=/docs/components-${kebabCase(componentName).toLowerCase()}--documentation`;

export const getTailframesFigmaUrl = (nodeId: string) => `${envs.figmaUrl}?node-id=${nodeId}`;
